import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import ItemList from '../../../shared/library/cards/item-list';
import {ComponentContainer} from './shared/styles';
import NavAnchor, {NAV_ANCHOR_OFFSET} from '../../tool-profile/components/shared/nav-anchor';
import withErrorBoundary from '../../../shared/enhancers/error-boundary';
import DescriptionCard from '../../../shared/library/cards/description';

const Container = glamorous.div({
  margin: '25px 0'
});

const BuiltFor = ({tool}) => {
  const tools = tool && tool.packageManager && tool.packageManager.packageManagerTools;

  const toolData =
    tools &&
    tools.map(tool => {
      return {
        name: tool.name,
        imageUrl: tool.imageUrl,
        thumbUrl: tool.thumbRetinaUrl,
        slug: tool.slug,
        path: tool.path,
        id: tool.id
      };
    });

  return (
    <ComponentContainer>
      <NavAnchor id="integrations" offset={NAV_ANCHOR_OFFSET} />
      <>
        <DescriptionCard heading="Built For" />
        <Container>
          <ItemList
            item={toolData}
            loading={false}
            hasNextPage={false}
            notFoundItem="Built for tools"
            loadMore={() => {}}
          />
        </Container>
      </>
    </ComponentContainer>
  );
};

BuiltFor.propTypes = {
  tool: PropTypes.object
};

export default withErrorBoundary(true)(BuiltFor);
